export default __webpack_public_path__ + "static/media/avatar_mice5.ab2057bb.mp3";